import { createSelector, createStructuredSelector } from "reselect";
import { selectActivationCode, selectUserName } from "scenes/selectors";
import { initialState, State as SecuritySetUpState } from "./redux";

/**
 * Direct selector to the securitySetUp state domain
 */

const selectSecuritySetUpDomain: (any) => SecuritySetUpState = (state) =>
  state.securitySetUp || initialState;

/**
 * Custom selectors to the securitySetUp state
 */

export const selectSecurityMethods = createSelector(
  selectSecuritySetUpDomain,
  (substate) => substate.securityMethods
);

export const selectLoading = createSelector(
  selectSecuritySetUpDomain,
  (substate) => substate.loading
);

export const selectMessageBoolean = createSelector(
  selectSecuritySetUpDomain,
  (substate) => substate.hasSuccessMsgSeen
);

/**
 * Multi instance selectors exporting a factory
 */
export const makeSelectSecuritySetUp = () =>
  createSelector(selectSecuritySetUpDomain, (substate) => substate);

// add structured selectors here, which will be mapped as prop to scene component
export default createStructuredSelector({
  securityMethods: selectSecurityMethods,
  activationCode: selectActivationCode,
  isLoading: selectLoading,
  username: selectUserName,
  hasSuccessMsgSeen: selectMessageBoolean,
});
